import './InitiativeSubSection.scss';
import classNames from 'classnames';
import React from 'react';
import { SonarText } from '@ui/text';
function getTitle(title, count) {
    if (!Number.isInteger(count)) {
        return title;
    }
    return `${count} ${title}`;
}
export const InitiativeSubSection = ({ bold, children, className, count, direction = 'vertical', icon, id, reducedPadding = false, title }) => React.createElement("div", { className: classNames('initiative-sub-section', className), id: id },
    React.createElement("div", { className: classNames('sub-section-header', { 'reduced-padding': reducedPadding }) },
        React.createElement(SonarText, { className: 'sub-section-title', weight: bold ? 'semibold' : undefined },
            icon,
            getTitle(title, count)),
        direction === 'horizontal' ? React.createElement("div", { className: 'sub-section-children' }, children) : null),
    direction === 'vertical' ? children : null);
